// Profile.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./Profile.css";
import { logoutUser, ProfileUser, UserOrderHistory } from "../../Services/Operations/ProductAPI";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../Common Component/Navber";
import RentalFooter from "../Home/Footer";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { logout } from "../../Store/authSlice";



/* ── Design Tokens (mirrors Login theme) ── */
const css = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Jost:wght@300;400;500;600&display=swap');

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --gold: #C9962A;
  --gold-light: #E8C06A;
  --gold-pale: #FBF3E0;
  --gold-glow: rgba(201,150,42,0.18);
  --brown-dark: #2C1A0E;
  --brown-mid: #4A2E1A;
  --brown-soft: #7A5230;
  --white: #FFFFFF;
  --off-white: #FDFAF5;
  --cream: #F5EDD8;
  --text-muted: #9A7B5A;
  --border: rgba(201,150,42,0.22);
  --shadow: 0 32px 80px rgba(44,26,14,0.18), 0 8px 24px rgba(44,26,14,0.1);
  --sidebar-w: 240px;
}

body { font-family: 'Jost', sans-serif; background: var(--off-white); }

/* ── Shell ── */
.pp-shell {
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(ellipse at 15% 15%, rgba(201,150,42,0.10) 0%, transparent 45%),
    radial-gradient(ellipse at 85% 85%, rgba(44,26,14,0.08) 0%, transparent 45%),
    var(--off-white);
  animation: bg-drift 18s ease-in-out infinite alternate;
}

@keyframes bg-drift {
  0%   { background-position: 0% 0%, 100% 100%, 0 0; }
  100% { background-position: 8% 5%, 92% 95%, 0 0; }
}

/* floating orbs */
.pp-shell::before {
  content:''; position:fixed; top:-60px; right:-60px;
  width:320px; height:320px; border-radius:50%;
  border:1px solid rgba(201,150,42,0.12);
  animation: orb-float 8s ease-in-out infinite;
  pointer-events:none;
}
.pp-shell::after {
  content:''; position:fixed; bottom:-80px; left:-40px;
  width:240px; height:240px; border-radius:50%;
  border:1px solid rgba(201,150,42,0.07);
  animation: orb-float 11s ease-in-out infinite reverse;
  pointer-events:none;
}
@keyframes orb-float {
  0%,100% { transform: translate(0,0) scale(1); }
  50%      { transform: translate(12px,-16px) scale(1.04); }
}

/* ── Sidebar ── */
.pp-sidebar {
  width: var(--sidebar-w);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  flex-shrink: 0;
  background:
    radial-gradient(ellipse at 0% 0%, rgba(232,192,106,0.18) 0%, transparent 60%),
    radial-gradient(ellipse at 100% 100%, rgba(44,26,14,0.12) 0%, transparent 60%),
    #1E1008;
  border-right: 1px solid rgba(201,150,42,0.18);
  animation: sidebar-rise 0.6s cubic-bezier(0.22,1,0.36,1) both;
}

@keyframes sidebar-rise {
  from { opacity:0; transform: translateX(-24px); }
  to   { opacity:1; transform: translateX(0); }
}

/* gold shimmer bar on sidebar top */
.pp-sidebar::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background: linear-gradient(90deg, transparent, var(--gold), var(--gold-light), var(--gold), transparent);
  background-size: 200% 100%;
  animation: shimmer-line 3s linear infinite;
  z-index:2;
}
@keyframes shimmer-line {
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
}

.pp-sidebar-top {
  padding: 28px 20px 0;
}

.pp-back-btn {
  display: flex; align-items: center; gap: 8px;
  background: rgba(201,150,42,0.10);
  border: 1px solid rgba(201,150,42,0.20);
  border-radius: 10px;
  padding: 9px 14px;
  cursor: pointer;
  color: var(--gold-light);
  font-family: 'Jost', sans-serif;
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  transition: background 0.25s, transform 0.15s, box-shadow 0.2s;
  width: 100%;
  text-transform: uppercase;
}
.pp-back-btn:hover {
  background: rgba(201,150,42,0.18);
  box-shadow: 0 0 0 1px rgba(201,150,42,0.3);
  transform: translateX(-2px);
}
.pp-back-btn svg { width:15px; height:15px; stroke:var(--gold-light); fill:none; stroke-width:2; stroke-linecap:round; stroke-linejoin:round; }

.pp-brand {
  display: flex; flex-direction: column; align-items: center;
  padding: 28px 20px 20px;
  border-bottom: 1px solid rgba(201,150,42,0.12);
}

.pp-avatar-ring {
  width: 72px; height: 72px;
  border-radius: 50%;
  background: linear-gradient(145deg, var(--brown-mid), var(--brown-dark));
  display: flex; align-items: center; justify-content: center;
  border: 2px solid var(--gold);
  box-shadow: 0 0 0 5px rgba(201,150,42,0.12), 0 8px 24px rgba(0,0,0,0.3);
  position: relative;
  overflow: hidden;
}
.pp-avatar-ring::after {
  content:'';
  position:absolute; inset:0;
  background: conic-gradient(from 0deg, var(--gold), transparent, var(--gold));
  border-radius:50%;
  opacity:0.12;
  animation: spin 8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.pp-avatar-initials {
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.6rem; font-weight: 700;
  color: var(--gold-light);
  z-index: 1; line-height:1;
  position: relative;
}

.pp-sidebar-name {
  font-family: 'Cormorant Garamond', serif;
  font-size: 0.95rem; font-weight: 600;
  color: var(--gold-pale);
  margin-top: 10px; text-align: center; line-height:1.3;
}
.pp-sidebar-email {
  font-size: 0.68rem; color: var(--text-muted);
  margin-top: 3px; text-align: center;
  letter-spacing: 0.03em;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  max-width: 190px;
}

/* ── Nav links ── */
.pp-nav {
  flex: 1;
  padding: 20px 14px;
  display: flex; flex-direction: column; gap: 6px;
}

.pp-nav-item {
  display: flex; align-items: center; gap: 11px;
  padding: 11px 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
  position: relative;
  border: 1px solid transparent;
  font-size: 0.83rem; font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(201,150,42,0.6);
  font-family: 'Jost', sans-serif;
}
.pp-nav-item svg {
  width:17px; height:17px; stroke:currentColor; fill:none;
  stroke-width:1.6; stroke-linecap:round; stroke-linejoin:round;
  flex-shrink:0; transition: transform 0.2s;
}
.pp-nav-item:hover {
  background: rgba(201,150,42,0.07);
  color: var(--gold-light);
  transform: translateX(3px);
}
.pp-nav-item.active {
  background: linear-gradient(90deg, rgba(201,150,42,0.18) 0%, rgba(201,150,42,0.06) 100%);
  color: var(--gold-light);
  border-color: rgba(201,150,42,0.25);
  box-shadow: inset 3px 0 0 var(--gold);
}
.pp-nav-item.active svg { transform: scale(1.1); }

/* active dot */
.pp-nav-item.active::after {
  content:'';
  position:absolute; right:12px; top:50%; transform:translateY(-50%);
  width:5px; height:5px; border-radius:50%; background:var(--gold);
  box-shadow: 0 0 6px var(--gold);
}

/* ── Logout ── */
.pp-sidebar-footer {
  padding: 16px 14px 24px;
  border-top: 1px solid rgba(201,150,42,0.12);
}
.pp-logout-btn {
  display: flex; align-items: center; gap: 10px;
  width: 100%; padding: 11px 14px;
  border: 1px solid rgba(201,150,42,0.15);
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  font-family: 'Jost', sans-serif;
  font-size: 0.8rem; font-weight: 500;
  letter-spacing: 0.06em; text-transform: uppercase;
  color: rgba(201,150,42,0.55);
  transition: all 0.25s;
}
.pp-logout-btn svg { width:15px; height:15px; stroke:currentColor; fill:none; stroke-width:1.8; stroke-linecap:round; stroke-linejoin:round; }
.pp-logout-btn:hover {
  background: rgba(180,40,40,0.12);
  border-color: rgba(200,70,70,0.35);
  color: #E88080;
}

/* ── Main content ── */
.pp-main {
  flex: 1;
  padding: 36px 40px;
  overflow-y: auto;
  animation: main-rise 0.7s 0.1s cubic-bezier(0.22,1,0.36,1) both;
}
@keyframes main-rise {
  from { opacity:0; transform: translateY(18px); }
  to   { opacity:1; transform: translateY(0); }
}

/* ── Section header ── */
.pp-section-header {
  display: flex; align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 28px;
}
.pp-section-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 2.2rem; font-weight: 700;
  color: var(--brown-dark);
  letter-spacing: 0.01em; line-height:1;
}
.pp-section-sub {
  font-size: 0.72rem; font-weight: 400;
  color: var(--text-muted); letter-spacing: 0.08em;
  text-transform: uppercase; margin-top: 4px;
}
.pp-gold-accent {
  width: 40px; height: 2px;
  background: linear-gradient(90deg, var(--gold), var(--gold-light));
  margin-top: 8px; border-radius: 2px;
}

/* ── Profile card ── */
.pp-profile-grid {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 24px;
}

.pp-profile-card {
  background:
    radial-gradient(ellipse at 0% 0%, rgba(232,192,106,0.2) 0%, transparent 60%),
    #FEFCF7;
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 28px 22px;
  display: flex; flex-direction: column; align-items: center;
  box-shadow: var(--shadow);
  position: relative; overflow: hidden;
  animation: card-in 0.5s 0.2s ease both;
}
@keyframes card-in {
  from { opacity:0; transform: scale(0.97) translateY(10px); }
  to   { opacity:1; transform: scale(1) translateY(0); }
}

/* shimmer bar on card top */
.pp-profile-card::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background: linear-gradient(90deg, transparent, var(--gold), var(--gold-light), var(--gold), transparent);
  background-size:200% 100%; animation: shimmer-line 3s linear infinite;
}

.pp-large-avatar {
  width: 100px; height: 100px; border-radius: 50%;
  background: linear-gradient(145deg, #3A2010, #2C1A0E);
  display: flex; align-items: center; justify-content: center;
  border: 2.5px solid var(--gold);
  box-shadow: 0 0 0 6px rgba(201,150,42,0.1), 0 10px 30px rgba(0,0,0,0.15);
  margin-bottom: 16px; position: relative; overflow: hidden;
}
.pp-large-avatar::after {
  content:''; position:absolute; inset:0;
  background: conic-gradient(from 0deg, rgba(201,150,42,0.3), transparent 60%, rgba(201,150,42,0.1));
  border-radius:50%; animation: spin 10s linear infinite;
}
.pp-large-avatar-initials {
  font-family:'Cormorant Garamond',serif; font-size:2.2rem; font-weight:700;
  color:var(--gold-light); z-index:1; position:relative;
}

.pp-profile-name {
  font-family:'Cormorant Garamond',serif; font-size:1.15rem; font-weight:700;
  color:var(--brown-dark); text-align:center; line-height:1.2; margin-bottom:4px;
}
.pp-profile-tag {
  font-size:0.67rem; letter-spacing:0.1em; text-transform:uppercase;
  color:var(--text-muted); font-weight:500; text-align:center;
}

.pp-profile-divider {
  width:100%; height:1px; background:var(--border);
  margin: 18px 0;
}

.pp-profile-stat {
  display: flex; flex-direction: column; align-items: center;
  gap: 2px; width: 100%;
}
.pp-stat-label {
  font-size:0.63rem; text-transform:uppercase; letter-spacing:0.1em;
  color:var(--text-muted); font-weight:600;
}
.pp-stat-val {
  font-size:0.82rem; color:var(--brown-mid); font-weight:500;
}

/* ── Info grid ── */
.pp-info-card {
  background:
    radial-gradient(ellipse at 100% 0%, rgba(232,192,106,0.12) 0%, transparent 55%),
    #FEFCF7;
  border:1px solid var(--border); border-radius:20px;
  box-shadow: var(--shadow); overflow:hidden;
  animation: card-in 0.5s 0.3s ease both;
}
.pp-info-card-header {
  padding: 22px 28px 14px;
  display: flex; align-items: center; gap: 10px;
}
.pp-info-card-title {
  font-family:'Cormorant Garamond',serif; font-size:1.2rem; font-weight:600;
  color:var(--brown-dark);
}
.pp-info-card-icon {
  width:34px; height:34px; border-radius:10px;
  background: linear-gradient(135deg, var(--brown-dark), var(--brown-mid));
  display:flex; align-items:center; justify-content:center;
  box-shadow: 0 4px 12px rgba(44,26,14,0.2);
}
.pp-info-card-icon svg { width:16px; height:16px; stroke:var(--gold-light); fill:none; stroke-width:1.6; stroke-linecap:round; stroke-linejoin:round; }

.pp-info-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 0;
}
.pp-info-item {
  padding: 16px 28px;
  border-top: 1px solid var(--border);
  border-right: 1px solid var(--border);
  transition: background 0.2s;
  position: relative;
}
.pp-info-item:hover { background: rgba(251,243,224,0.6); }
.pp-info-item:nth-child(even) { border-right: none; }
.pp-info-item-label {
  font-size:0.62rem; text-transform:uppercase; letter-spacing:0.1em;
  color:var(--text-muted); font-weight:600; margin-bottom:4px;
}
.pp-info-item-val {
  font-size:0.9rem; color:var(--brown-dark); font-weight:500;
}

/* badge */
.pp-badge {
  display:inline-block;
  padding:2px 10px; border-radius:20px;
  font-size:0.65rem; font-weight:600; letter-spacing:0.07em; text-transform:uppercase;
  background:rgba(201,150,42,0.14); color:var(--gold);
  border:1px solid rgba(201,150,42,0.3);
}

/* ── History section ── */
.pp-history-list {
  display: flex; flex-direction: column; gap: 16px;
}

.pp-hist-card {
  background:
    radial-gradient(ellipse at 0% 50%, rgba(232,192,106,0.09) 0%, transparent 50%),
    #FEFCF7;
  border:1px solid var(--border); border-radius:18px;
  box-shadow: 0 4px 20px rgba(44,26,14,0.07);
  overflow:hidden;
  transition: transform 0.22s, box-shadow 0.22s;
  animation: hist-in 0.5s ease both;
  cursor: default;
}
.pp-hist-card:nth-child(1) { animation-delay: 0.05s; }
.pp-hist-card:nth-child(2) { animation-delay: 0.12s; }
.pp-hist-card:nth-child(3) { animation-delay: 0.18s; }
.pp-hist-card:nth-child(4) { animation-delay: 0.24s; }
.pp-hist-card:nth-child(5) { animation-delay: 0.30s; }

@keyframes hist-in {
  from { opacity:0; transform:translateY(16px) scale(0.98); }
  to   { opacity:1; transform:translateY(0) scale(1); }
}
.pp-hist-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 40px rgba(44,26,14,0.12);
}

.pp-hist-inner {
  display: flex; align-items: stretch; gap: 0;
}

.pp-hist-stripe {
  width: 4px; flex-shrink: 0;
  border-radius: 4px 0 0 4px;
}
.stripe-available { background: linear-gradient(to bottom, #4caf7a, #2e7d52); }
.stripe-rented    { background: linear-gradient(to bottom, var(--gold), #A87820); }
.stripe-pending   { background: linear-gradient(to bottom, #6a9fd8, #3a6ea8); }

.pp-hist-body {
  flex:1; padding:18px 22px;
  display:flex; align-items:center; justify-content:space-between; gap:16px;
}

.pp-hist-left {}
.pp-hist-prop-name {
  font-family:'Cormorant Garamond',serif; font-size:1.1rem; font-weight:700;
  color:var(--brown-dark); line-height:1.2; margin-bottom:3px;
}
.pp-hist-meta {
  font-size:0.72rem; color:var(--text-muted); display:flex; align-items:center; gap:5px;
  margin-bottom:8px;
}
.pp-hist-meta svg { width:12px; height:12px; stroke:var(--text-muted); fill:none; stroke-width:1.8; stroke-linecap:round; stroke-linejoin:round; }
.pp-hist-chips {
  display:flex; gap:7px; flex-wrap:wrap;
}
.pp-chip {
  padding:2px 9px; border-radius:20px; font-size:0.62rem; font-weight:600;
  letter-spacing:0.06em; text-transform:uppercase; border:1px solid;
}
.chip-type {
  background:rgba(201,150,42,0.1); color:var(--gold); border-color:rgba(201,150,42,0.3);
}
.chip-furnish {
  background:rgba(122,82,48,0.08); color:var(--brown-soft); border-color:rgba(122,82,48,0.25);
}
.chip-status-available { background:rgba(76,175,122,0.1); color:#2e7d52; border-color:rgba(76,175,122,0.3); }
.chip-status-rented    { background:rgba(201,150,42,0.12); color:#8a6010; border-color:rgba(201,150,42,0.35); }

.pp-hist-right {
  text-align:right; flex-shrink:0;
}
.pp-hist-rent {
  font-family:'Cormorant Garamond',serif; font-size:1.55rem; font-weight:700;
  color:var(--brown-dark); line-height:1;
}
.pp-hist-rent-label {
  font-size:0.63rem; color:var(--text-muted); text-transform:uppercase;
  letter-spacing:0.08em; margin-bottom:4px;
}
.pp-hist-deposit {
  font-size:0.72rem; color:var(--text-muted); margin-top:3px;
}
.pp-hist-deposit span { color:var(--brown-soft); font-weight:500; }

/* ── history header chips ── */
.pp-history-header-row {
  display:flex; align-items:center; justify-content:space-between;
  margin-bottom: 22px;
}
.pp-hist-count-badge {
  padding:5px 14px; border-radius:20px;
  background:rgba(201,150,42,0.12); border:1px solid rgba(201,150,42,0.25);
  font-size:0.72rem; font-weight:600; color:var(--gold); letter-spacing:0.06em;
}

/* ── Responsive ── */
@media (max-width: 860px) {
  .pp-sidebar { width:200px; }
  .pp-profile-grid { grid-template-columns:1fr; }
  .pp-main { padding:24px 20px; }
  .pp-hist-body { flex-direction:column; align-items:flex-start; }
  .pp-hist-right { text-align:left; }
}
@media (max-width: 640px) {
  .pp-shell { flex-direction: column; }
  .pp-sidebar { width:100%; min-height:auto; }
  .pp-nav { flex-direction:row; padding:8px 14px; gap:8px; }
  .pp-nav-item.active::after { display:none; }
  .pp-info-grid { grid-template-columns:1fr; }
  .pp-info-item:nth-child(even) { border-right:1px solid var(--border); }
}
`;

/* ── Dummy data ── */
const USER = {
  id: 15,
  full_name: "Surajit Roy Siance",
  email: "surajit11@gmail.com",
  birth_date: "2000-10-18T00:00:00.000000Z",
  profile_image: null,
  phone: "7458961023",
  created_at: "2026-04-27T10:27:57.000000Z",
};

const HISTORY = [
  {
    id: 10, property_name: "Dream Nest Apartments", property_type: "apartment",
    description: "Family-friendly apartments with security",
    address: "Garia Main Road", city: "Kolkata", state: "West Bengal", country: "India",
    pincode: "700084", total_units: 1, available_units: 1,
    rent_amount: "22000.00", security_deposit: "44000.00",
    furnishing_status: "furnished", status: "available", created_at: "2026-04-08 11:52:07",
  },
  {
    id: 9, property_name: "Tech Park Towers", property_type: "commercial",
    description: "Office spaces for IT companies",
    address: "Sector V Tech Park", city: "Kolkata", state: "West Bengal", country: "India",
    pincode: "700091", total_units: 1, available_units: 1,
    rent_amount: "60000.00", security_deposit: "120000.00",
    furnishing_status: "unfurnished", status: "rented", created_at: "2026-04-08 11:52:07",
  },
  {
    id: 7, property_name: "Green Valley Villa", property_type: "villa",
    description: "Luxury villa with private garden",
    address: "New Town Block B", city: "Kolkata", state: "West Bengal", country: "India",
    pincode: "700156", total_units: 1, available_units: 1,
    rent_amount: "85000.00", security_deposit: "170000.00",
    furnishing_status: "furnished", status: "available", created_at: "2026-03-14 09:30:00",
  },
];

/* ── SVG Icons ── */
const Ico = ({ d, ...p }) => (
  <svg viewBox="0 0 24 24" style={{ width: p.size||16, height: p.size||16, stroke: "currentColor", fill: "none", strokeWidth: p.sw||1.6, strokeLinecap:"round", strokeLinejoin:"round" }}>
    {Array.isArray(d) ? d.map((seg,i)=><path key={i} d={seg}/>) : <path d={d}/>}
    {p.children}
  </svg>
);

const IconBack = () => <Ico d="M19 12H5M12 5l-7 7 7 7" />;
const IconUser = () => <Ico d={["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2","M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"]} />;
const IconHistory = () => <Ico d={["M12 8v4l3 3","M3.05 11a9 9 0 1 1 .5 3.5"]}><path d="M3 4v7h7"/></Ico>;
const IconLogout = () => <Ico d={["M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4","M16 17l5-5-5-5","M21 12H9"]} />;
const IconMail = () => <Ico d={["M2 4h20v16H2zM2 4l10 9 10-9"]} />;
const IconPhone = () => <Ico d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3-8.63A2 2 0 0 1 3.68 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.9a16 16 0 0 0 6.29 6.29l1.18-1.18a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />;
const IconCalendar = () => <Ico d={["M3 9h18","M8 2v4","M16 2v4","M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6z"]} />;
const IconId = () => <Ico d={["M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z","M8 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z","M14 9h4","M14 13h4","M8 15h8"]} />;
const IconLocation = () => <Ico d={["M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z","M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"]} />;
const IconBuilding = () => <Ico d={["M3 21h18","M5 21V7l8-4v18","M19 21V11l-6-4","M9 9v2","M9 13v2","M9 17v2","M13 13v2","M13 17v2"]} />;
const IconRupee = () => <Ico d={["M6 3h12","M6 8h12","M6 13l8.5 8","M6 13h3a4.5 4.5 0 0 0 0-9H6"]} />;

/* ── Helper ── */
const fmt = (s) => "₹" + Number(s).toLocaleString("en-IN");
const fmtDate = (s) => new Date(s).toLocaleDateString("en-IN",{ day:"numeric", month:"long", year:"numeric" });
const initials = (name) => name.split(" ").filter(Boolean).slice(0,2).map(w=>w[0]).join("").toUpperCase();
const capitalize = (s) => s ? s[0].toUpperCase()+s.slice(1) : "";

/* ══════════════════════════════════════════
   SUB-COMPONENT: Profile
══════════════════════════════════════════ */
const ProfileSection = ({ user }) => {
  
  
  return(
  <div>
    <div className="pp-section-header">
      <div>
        <div className="pp-section-title">My Profile</div>
        <div className="pp-section-sub">Personal information & account details</div>
        <div className="pp-gold-accent" />
      </div>
    </div>

    <div className="pp-profile-grid">
      {/* Left card */}
      <div className="pp-profile-card">
        <div className="pp-large-avatar">
          <span className="pp-large-avatar-initials">{initials(user.full_name)}</span>
        </div>
        <div className="pp-profile-name">{user.full_name}</div>
        <div className="pp-profile-tag">Member</div>
        <div className="pp-profile-divider" />
        <div className="pp-profile-stat">
          <span className="pp-stat-label">Member Since</span>
          <span className="pp-stat-val">{fmtDate(user.created_at)}</span>
        </div>
        <div style={{marginTop:10}}>
          <span className="pp-badge">✦ Verified Account</span>
        </div>
      </div>

      {/* Right info card */}
      <div className="pp-info-card">
        <div className="pp-info-card-header">
          <div className="pp-info-card-icon"><IconId /></div>
          <div className="pp-info-card-title">Account Information</div>
        </div>
        <div className="pp-info-grid">
          <div className="pp-info-item">
            <div className="pp-info-item-label">
              <span style={{display:"flex",alignItems:"center",gap:5}}>
                <IconUser /> Full Name
              </span>
            </div>
            <div className="pp-info-item-val">{user.full_name}</div>
          </div>
          <div className="pp-info-item">
            <div className="pp-info-item-label">
              <span style={{display:"flex",alignItems:"center",gap:5}}>
                <IconId /> User ID
              </span>
            </div>
            <div className="pp-info-item-val"># {user.id}</div>
          </div>
          <div className="pp-info-item">
            <div className="pp-info-item-label">
              <span style={{display:"flex",alignItems:"center",gap:5}}>
                <IconMail /> Email Address
              </span>
            </div>
            <div className="pp-info-item-val" style={{wordBreak:"break-all"}}>{user.email}</div>
          </div>
          <div className="pp-info-item">
            <div className="pp-info-item-label">
              <span style={{display:"flex",alignItems:"center",gap:5}}>
                <IconPhone /> Phone
              </span>
            </div>
            <div className="pp-info-item-val">{user.phone}</div>
          </div>
          <div className="pp-info-item">
            <div className="pp-info-item-label">
              <span style={{display:"flex",alignItems:"center",gap:5}}>
                <IconCalendar /> Date of Birth
              </span>
            </div>
            <div className="pp-info-item-val">{fmtDate(user.birth_date)}</div>
          </div>
          <div className="pp-info-item">
            <div className="pp-info-item-label">
              <span style={{display:"flex",alignItems:"center",gap:5}}>
                <IconCalendar /> Last Updated
              </span>
            </div>
            <div className="pp-info-item-val">{fmtDate(user.created_at)}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

/* ══════════════════════════════════════════
   SUB-COMPONENT: History
══════════════════════════════════════════ */
const HistorySection = ({ history }) => (
  <div>
    <div className="pp-section-header">
      <div>
        <div className="pp-section-title">Rental History</div>
        <div className="pp-section-sub">Properties you've viewed or rented</div>
        <div className="pp-gold-accent" />
      </div>
    </div>

    <div className="pp-history-header-row">
      <div style={{fontSize:"0.78rem",color:"var(--text-muted)"}}>Showing {history.length} properties</div>
      <div className="pp-hist-count-badge">{history.length} Records</div>
    </div>

    <div className="pp-history-list">
      {history.map(p => {
        const stripeClass = p.status === "available" ? "stripe-available" : p.status === "rented" ? "stripe-rented" : "stripe-pending";
        const statusChipClass = p.status === "available" ? "chip-status-available" : "chip-status-rented";
        return (
          <div className="pp-hist-card" key={p.id}>
            <div className="pp-hist-inner">
              <div className={`pp-hist-stripe ${stripeClass}`} />
              <div className="pp-hist-body">
                <div className="pp-hist-left">
                  <div className="pp-hist-prop-name">{p.property_name}</div>
                  <div className="pp-hist-meta">
                    <IconLocation />
                    {p.address}, {p.city}, {p.state} – {p.pincode}
                  </div>
                  <div className="pp-hist-chips">
                    <span className="pp-chip chip-type">{capitalize(p.property_type)}</span>
                    <span className="pp-chip chip-furnish">{capitalize(p.furnishing_status)}</span>
                    <span className={`pp-chip ${statusChipClass}`}>{capitalize(p.status)}</span>
                  </div>
                </div>
                <div className="pp-hist-right">
                  <div className="pp-hist-rent-label">Rent / month</div>
                  <div className="pp-hist-rent">{fmt(p.rent_amount)}</div>
                  <div className="pp-hist-deposit">Deposit: <span>{fmt(p.security_deposit)}</span></div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

/* ══════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════ */
export default function Profile() {
  const [tab, setTab] = useState("profile");
      const[user,setUser]=useState()
      const [history,setHistory]=useState(HISTORY)
    const navigate=useNavigate()
    const dispatch=useDispatch()
  
  
     const { isAuthenticated ,token} = useSelector((state) => state.auth);
  
  
    const handleGetProfile=async()=>{
      try {
        if(!token){
          navigate("/login")
        }
        console.log(token);
        
          const res =await ProfileUser(token)
          const response=await UserOrderHistory(token)
          console.log('handleGetProfile',res);
          console.log('handleGetHistory',response);
          setUser(res.data.data)
          setHistory(response.data.data)
         console.log(isAuthenticated,user);
         
          
      } catch (error) {
         console.log(error);
          
      }
    }
  
    const handlerLogout=async()=>{
      try {
          console.log(token);
           dispatch(logout())
          const res =await logoutUser(token)
          console.log(res);
          if(res.status===200){
             
            toast.success("Logged out successfully")
            navigate("/login")
          }
          
      } catch (error) {
          console.log(error);
           dispatch(logout)
           navigate("/")
      }
    }
  
    useEffect(() => {
      handleGetProfile()
    }, [])

    if(!user){
      return(
         <div className="pp-shell pp-sk-root">

      {/* SIDEBAR */}
      <aside className="pp-sidebar">

        <div className="pp-sidebar-top">
          <div className="pp-sk-btn shimmer" />
        </div>

        <div className="pp-brand">
          <div className="pp-sk-avatar-ring shimmer" />
          <div className="pp-sk-name shimmer" />
          <div className="pp-sk-email shimmer" />
        </div>

        <nav className="pp-nav">
          <div className="pp-sk-nav shimmer" />
          <div className="pp-sk-nav shimmer" />
        </nav>

        <div className="pp-sidebar-footer">
          <div className="pp-sk-logout shimmer" />
        </div>

      </aside>

      {/* MAIN */}
      <main className="pp-main">

        {/* HEADER */}
        <div className="pp-section-header">
          <div>
            <div className="pp-sk-title shimmer" />
            <div className="pp-sk-sub shimmer" />
            <div className="pp-gold-accent" />
          </div>
        </div>

        {/* PROFILE TAB */}
        {tab === "profile" && (
          <div className="pp-profile-grid">

            {/* LEFT CARD */}
            <div className="pp-profile-card">

              <div className="pp-sk-large-avatar shimmer" />

              <div className="pp-sk-profile-name shimmer" />
              <div className="pp-sk-profile-tag shimmer" />

              <div className="pp-profile-divider" />

              <div className="pp-profile-stat">
                <div className="pp-sk-stat-label shimmer" />
                <div className="pp-sk-stat-val shimmer" />
              </div>

              <div style={{ marginTop: 14 }}>
                <div className="pp-sk-badge shimmer" />
              </div>

            </div>

            {/* INFO CARD */}
            <div className="pp-info-card">

              <div className="pp-info-card-header">
                <div className="pp-sk-info-icon shimmer" />
                <div className="pp-sk-info-title shimmer" />
              </div>

              <div className="pp-info-grid">

                {[1,2,3,4,5,6].map(i => (
                  <div className="pp-info-item" key={i}>
                    <div className="pp-sk-item-label shimmer" />
                    <div className="pp-sk-item-value shimmer" />
                  </div>
                ))}

              </div>

            </div>

          </div>
        )}

        {/* HISTORY TAB */}
        {tab === "history" && (
          <>
            <div className="pp-history-header-row">
              <div className="pp-sk-small-line shimmer w-30" />
              <div className="pp-sk-chip shimmer" />
            </div>

            <div className="pp-history-list">

              {[1,2,3,4].map(i => (
                <div className="pp-hist-card" key={i}>

                  <div className="pp-hist-inner">

                    <div className="pp-sk-stripe" />

                    <div className="pp-hist-body">

                      <div className="pp-hist-left">

                        <div className="pp-sk-hist-title shimmer" />

                        <div className="pp-sk-small-line shimmer w-70 mb-10" />

                        <div className="pp-hist-chips">
                          <div className="pp-sk-chip shimmer" />
                          <div className="pp-sk-chip shimmer" />
                          <div className="pp-sk-chip shimmer" />
                        </div>

                      </div>

                      <div className="pp-hist-right">

                        <div className="pp-sk-small-line shimmer w-50 mb-10" />

                        <div className="pp-sk-rent shimmer" />

                        <div className="pp-sk-small-line shimmer w-60" />

                      </div>

                    </div>

                  </div>

                </div>
              ))}

            </div>
          </>
        )}

      </main>

    </div>
      )
    }

  return (
    <>
      <style>{css}</style>
      <div className="pp-shell">

        {/* ── Sidebar ── */}
        <aside className="pp-sidebar">
          {/* Back button */}
          <div className="pp-sidebar-top">
            <button className="pp-back-btn" onClick={() => navigate(-1)}>
              <IconBack /> Back
            </button>
          </div>

          {/* Mini avatar + name */}
          <div className="pp-brand">
            <div className="pp-avatar-ring">
              <span className="pp-avatar-initials">{initials(user?.full_name)}</span>
            </div>
            <div className="pp-sidebar-name">{user?.full_name}</div>
            <div className="pp-sidebar-email">{user?.email}</div>
          </div>

          {/* Nav */}
          <nav className="pp-nav">
            <div className={`pp-nav-item ${tab==="profile"?"active":""}`} onClick={()=>setTab("profile")}>
              <IconUser /> Profile
            </div>
            <div className={`pp-nav-item ${tab==="history"?"active":""}`} onClick={()=>setTab("history")}>
              <IconHistory /> History
            </div>
          </nav>

          {/* Logout */}
          <div className="pp-sidebar-footer">
            <button className="pp-logout-btn" onClick={() => handlerLogout()}>
              <IconLogout /> Log out
            </button>
          </div>
        </aside>

        {/* ── Main panel ── */}
        <main className="pp-main" key={tab}>
          {tab === "profile"
            ? <ProfileSection user={user} />
            : <HistorySection history={history} />
          }
        </main>

      </div>
    </>
  );
}
